import { render, staticRenderFns } from "./ConfigureRulesModal.vue?vue&type=template&id=c5fb4196&scoped=true"
import script from "./ConfigureRulesModal.vue?vue&type=script&lang=js"
export * from "./ConfigureRulesModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigureRulesModal.vue?vue&type=style&index=0&id=c5fb4196&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fb4196",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5fb4196')) {
      api.createRecord('c5fb4196', component.options)
    } else {
      api.reload('c5fb4196', component.options)
    }
    module.hot.accept("./ConfigureRulesModal.vue?vue&type=template&id=c5fb4196&scoped=true", function () {
      api.rerender('c5fb4196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supplier/components/ConfigureRulesModal.vue"
export default component.exports